module.exports = __webpack_public_path__ + "img/Logos-EJ-michelin-NB.1b4ea387.jpg";